module.exports = __webpack_public_path__ + "img/s1_t2_01.2a6a91cf.jpeg";